import React from "react";
import { Briefcase, CheckCircle, Clock, DollarSign } from "lucide-react";
import { Link } from "react-router-dom";

interface StatsGridProps {
  stats: {
    activeProjects: number;
    completedProjects: number;
    pendingApplications: number;
    totalEarnings: number;
    successRate: number;
    averageRating: number;
  };
  loading?: boolean;
}

const StatsGrid: React.FC<StatsGridProps> = ({ stats, loading = false }) => {
  const statItems = [
    {
      label: "Active Projects",
      value: stats.activeProjects,
      icon: Briefcase,
      color: "bg-blue-500",
      href: "/projects?tab=my_projects",
    },
    {
      label: "Completed",
      value: stats.completedProjects,
      icon: CheckCircle,
      color: "bg-green-500",
      href: "/projects?tab=my_projects",
    },
    {
      label: "Pending",
      value: stats.pendingApplications,
      icon: Clock,
      color: "bg-yellow-500",
      href: "/projects?tab=pending",
    },
    {
      label: "Total Earnings",
      value: `$${stats.totalEarnings.toLocaleString()}`,
      icon: DollarSign,
      color: "bg-emerald-500",
      href: "/payments",
    },
    // {
    //   label: "Success Rate",
    //   value: `${stats.successRate}%`,
    //   icon: TrendingUp,
    //   color: "bg-purple-500",
    // },
    // {
    //   label: "Avg Rating",
    //   value: stats.averageRating.toFixed(1),
    //   icon: Star,
    //   color: "bg-orange-500",
    // },
  ];

  if (loading) {
    return (
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {[...Array(6)].map((_, i) => (
          <div
            key={i}
            className="bg-white rounded-lg p-4 shadow-sm animate-pulse"
          >
            <div className="h-10 w-10 bg-gray-200 rounded-lg mb-3"></div>
            <div className="h-6 bg-gray-200 rounded w-16 mb-1"></div>
            <div className="h-4 bg-gray-200 rounded w-20"></div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {statItems.map((item) => (
        <Link key={item.label} to={item.href}>
          <div
            key={item.label}
            className="bg-white rounded-lg p-4 shadow-sm hover:shadow-md transition-shadow"
          >
            <div
              className={`${item.color} w-10 h-10 rounded-lg flex items-center justify-center mb-3`}
            >
              <item.icon className="w-5 h-5 text-white" />
            </div>
            <p className="text-2xl font-bold text-gray-900">{item.value}</p>
            <p className="text-sm text-gray-500">{item.label}</p>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default StatsGrid;
